import moment from 'moment'
import Set from '@/models/set'

class Tournament{

  constructor(
    id,
    name,
    startDate,
    endDate,
    price,
    currency,
    numberOfSets,
    periodicity,
    gol,
    penalties,
    pointsPerMatchWon,
    pointsPerMatchDraw,
    matchSuspensionsPerRed,
    matchSuspensionsPerDoubleYellow,
    status,
    sets,
    acceptRegistries,
    teamApproval,
    totalAccessPetitions,
    scheduleMatches,
    team_type,
    player_validation,
    mode,
    is_femexfut
  )
  {

    this.id = id || -1
    this.name = name || ""
    this.startDate = startDate || moment().format('YYYY-MM-DD')
    this.endDate = endDate || moment().format('YYYY-MM-DD')
    this.currency = currency || ""
    this.price = parseFloat(price) || ""
    this.numberOfSets = parseInt(numberOfSets) || ""
    this.periodicity = parseInt(periodicity) || ""
    this.gol = Boolean(gol) || false
    this.penalties = Boolean(penalties) || false
    this.pointsPerMatchWon = parseInt(pointsPerMatchWon) || ""
    this.pointsPerMatchDraw = parseInt(pointsPerMatchDraw) || ""
    this.matchSuspensionsPerRed = parseInt(matchSuspensionsPerRed) || ""
    this.matchSuspensionsPerDoubleYellow = parseInt(matchSuspensionsPerDoubleYellow) || ""
    this.status = status || "active"
    this.sets = sets || []
    this.registries = acceptRegistries || false
    this.team_approval = teamApproval || false
    this.totalAccessPetitions = totalAccessPetitions || 0
    this.scheduleMatches = scheduleMatches || 0
    this.team_type = team_type || 0
    this.player_validation = player_validation || false
    this.mode = mode || "normal"
    this.is_femexfut = Boolean(is_femexfut) || false
  }


  static parse(responseData){
    if(!responseData) return new Team()

    let d = responseData
    var sets = []
    if(d.sets){
      for(var i = 0; i < d.sets.length; i++){
        let set = Set.parse(d.sets[i])
        sets.push(set)
      }
    }
    return new Tournament(
      d.id,
      d.name,
      d.start_date,
      d.end_date,
      d.price,
      d.currency,
      d.number_of_sets,
      d.periodicity,
      d.gol,
      d.penalties,
      d.points_per_match_won,
      d.points_per_match_draw,
      d.match_suspensions_per_red,
      d.match_suspensions_per_double_yellow,
      d.status,
      sets,
      d.registries,
      d.team_approval,
      d.total_access_petitions,
      d.schedule_matches,
      d.team_type,
      d.player_validation,
      d.mode,
      d.is_femexfut
    )
  }
}


export default Tournament



// WEBPACK FOOTER //
// ./src/models/tournament.js